module.exports = __webpack_public_path__ + "static/media/029-x rays.7b32a863.svg";